import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { OptionsFormComponent } from './options-form/options-form.component';
import { OptionsFormV2Component } from './options-form-v2/options-form-v2.component';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask/src/currency-mask.config';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
};

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
  ],
  declarations: [
    OptionsFormComponent,
    OptionsFormV2Component,
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ],
  entryComponents: [
    OptionsFormComponent,
    OptionsFormV2Component,
  ]
})
export class ReverseModule { }

try {
  angular.module('mandaeApp')
      .directive('appReverseOptionsForm', downgradeComponent({ component: OptionsFormComponent }))
      .directive('appReverseOptionsFormV2', downgradeComponent({ component: OptionsFormV2Component }));
} catch (e) {}
